import { render, staticRenderFns } from "./carExhibitionProductManager.vue?vue&type=template&id=6cf5ae61&lang=html"
import script from "./carExhibitionProductManager.vue?vue&type=script&lang=js"
export * from "./carExhibitionProductManager.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports